import { ComptageRule } from '../models/models';

export class ComptageUtils {
  /**
   * Logic for calculating the comptage type based on voltage and power.
   */
  public static calculateComptageType(
    voltage: string | undefined,
    p1: string | undefined,
    p2: string | undefined,
    currentComptage: string | undefined,
    activeRule?: ComptageRule
  ): string {
    if (activeRule) {
      return this.applyRule(voltage, p1, p2, activeRule);
    }

    // Fallback to hardcoded logic if no rule provided
    if (p2 && p2 !== 'N/A' && p2.trim() !== '') {
      return 'Comptage HT';
    }

    if (voltage && p1) {
      const tensionValue = parseFloat(voltage.replace(/[^\d.]/g, ''));
      const puissanceValue = parseFloat(p1.replace(/[^\d.]/g, ''));

      if (isNaN(tensionValue) || isNaN(puissanceValue)) return currentComptage || '';

      if (tensionValue === 10 && puissanceValue >= 800) {
        return 'Comptage HT';
      } else if (tensionValue >= 15 && puissanceValue > 1250) {
        return 'Comptage HT';
      } else {
        return 'Comptage BT';
      }
    }

    return currentComptage || '';
  }

  private static applyRule(voltage: string | undefined, p1: string | undefined, p2: string | undefined, rule: ComptageRule): string {
    const hasP2 = p2 && p2 !== 'N/A' && p2.trim() !== '';
    if (hasP2) {
      return 'Comptage HT';
    }

    if (voltage && p1) {
      const tensionValue = parseFloat(voltage.replace(/[^\d.]/g, ''));
      const puissanceValue = parseFloat(p1.replace(/[^\d.]/g, ''));

      if (isNaN(tensionValue) || isNaN(puissanceValue)) return 'Comptage BT';

      let isHT = false;
      const { minTension, maxTension, minPuissance, maxPuissance } = rule;

      if (minTension != null) {
        // 1. Below minimum voltage -> Always BT
        if (tensionValue < minTension) {
          return 'Comptage BT';
        }

        // 2. Above or equal to high voltage threshold
        if (maxTension != null && tensionValue >= maxTension) {
          return puissanceValue > maxPuissance ? 'Comptage HT' : 'Comptage BT';
        }

        // 3. Between min and max (or only min defined)
        return puissanceValue >= minPuissance ? 'Comptage HT' : 'Comptage BT';
      }

      return isHT ? 'Comptage HT' : 'Comptage BT';
    }

    return 'Comptage BT';
  }
}
